import { fetchingConstants } from '../_constants';

const initialState = {
    fetching_refreshtoken: false,
};

export function fetching(state = initialState, action) {
    switch(action.type) {
        case fetchingConstants.REFRESHTOKEN:
        return {
            fetching_refreshtoken: action.fetching_refreshtoken,
        };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/fetching.reducer.js